<template>
  <div
    class="wrapper"
  >
    <Product
      v-for="(product, index) in allProducts"
      :key="index"
      :class="['product-wrapper']"
      :product="product"
      @click.native="$router.push({ name: 'productPage', params: { name: product.title } })"
    />
    <div
      v-show="!allProducts.length"
      class="no-products"
    >
      <p>
        {{ strings.products.noProducts_ }}
      </p>
    </div>
  </div>
</template>

<script>
import Product from '@/components/shop/Product.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'Products',
  components: {
    Product
  },
  computed: {
    ...mapGetters(['allProducts', 'strings'])
  }
}
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped lang="scss">
.wrapper {
  width: 96%;
  margin-left: 2%;
  margin-right: 2%;
  margin-bottom: 30px;
  margin-top: 80px;
  transition-duration: 0.5s;
}
.wrapper-offset {
  transform: translateX(75vw);
}
.product-wrapper {
  width: 100%;
  margin-bottom: 30px;
}

.no-products {
  margin-top: 120px;
}

@media (min-width: 992px) {
  .wrapper {
    width: 100%;
    margin: 0;
    margin-top: 15vh;
  }
  .product-wrapper {
    margin: 0;
    width: 100%;
    margin-bottom: 10vh;
  }
}
</style>
